module.exports = __webpack_public_path__ + "img/1561632748.e9ee6f2c.jpg";